import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { ModuleDialogs } from '../../constants/Dialogs';

import buildContextMenu from '../Common/BuildContextMenu';
import { UserModuleEnrolmentTableRow } from './ModuleEnrolmentTableRow';
import TableView from '../Common/TableView';
import { withId } from '../Common/Decorators';
import ModuleEnrolmentDialog from './ModuleEnrolmentDialog';
import ModuleEnrolmentDeleteDialog from './ModuleEnrolmentDeleteDialog';

import IconPerson from 'material-ui/svg-icons/action/perm-identity';

import ModuleActions from '../../actions/ModuleActionCreator';
import UserActions from '../../actions/UserActionCreator';
import ModuleSubscriptionStore from '../../stores/ModuleSubscriptionStore';
import UserStore from '../../stores/UserStore';
import DialogStore from '../../stores/DialogStore';
import ModuleEventStore from '../../stores/ModuleEventStore';

class ModuleEnrolmentsByUser extends Component {

    componentWillMount() {
        this.setState({
            actions: buildContextMenu([{
                link: `/dashboard/user/${this.props.id}`,
                icon: <IconPerson />,
                label: 'User profile',
            }])
        });
    }

    componentDidMount() {
        this.onUserChange = this.onUserChange.bind(this);
        this.onModuleEventsChange = this.onModuleEventsChange.bind(this);
        this.saveEnrolment = this.saveEnrolment.bind(this);

        this.listeners = [
            UserStore.addListener(this.onUserChange),
            ModuleEventStore.addListener(this.onModuleEventsChange),
        ];

        ModuleActions.getUserSubscriptions(this.props.id);
        UserActions.getById(this.props.id);
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }

    getDialog() {
        switch (this.state.dialog) {
            case ModuleDialogs.ENROLMENT_EDIT:
                const moduleId = DialogStore.getValue('moduleId');
                let events;
                if (!!moduleId && DialogStore.getValue('moduleType') === 'classroom') {
                    if (this.state.classroomModuleIds.includes(moduleId)) {
                        events = ModuleEventStore.getByModule(moduleId);
                    } else {
                        ModuleActions.getEvents(moduleId);
                        events = [];
                    }
                }
                return (
                    <ModuleEnrolmentDialog
                        onSave={this.saveEnrolment}
                        title="Edit enrolment"
                        moduleId={moduleId}
                        events={events}
                    />
                );

            case ModuleDialogs.ENROLMENT_DELETE:
                return (
                    <ModuleEnrolmentDeleteDialog
                        onSave={this.onDeleteEnrolment}
                    />
                );

            default: break;
        }
    }

    render() {
        const headers = [
            'Enrolled',
            'Module',
            'Completed',
            'Status',
            '',
            '',
            ''
        ];

        return (
            <TableView
                title={`${this.state.user.firstName || ''} ${this.state.user.lastName || ''}`.trim()}
                subtitle='Enrolments'
                headers={headers}
                rows={this.state.subscriptions}
                decorator={UserModuleEnrolmentTableRow}
                backButton
                actions={this.state.actions}
            >
                { this.getDialog() }
            </TableView>
        );
    }

    onUserChange() {
        const user = UserStore.getById(this.props.id);
        if (!!user) {
            this.setState({user});
        }
    }

    onModuleEventsChange() {
        if (ModuleEventStore.isFetching()) { return; }
        const moduleId = DialogStore.getValue('moduleId');
        if (!moduleId) { return; } //guard: moduleId required
        if (this.state.classroomModuleIds.includes(moduleId)) { return; } //guard: already there

        this.setState({classroomModuleIds: this.state.classroomModuleIds.concat([moduleId])});
    }

    saveEnrolment(draft) {
        if (!draft.userId) { return false; } // userId is required
        const current = this.state.subscriptions.find((e) => (e !== undefined && e.moduleId === this.props.id && e.userId === draft.userId), this);
        const eventId = draft.eventId || (!!current && current.eventId) || null;
        if (draft.status === 'completed' && !!eventId) {

            const events = ModuleEventStore.getByModule(draft.moduleId);
            const event = (!!events && events.length > 0 ) && events.find((e) => e !== undefined && e.id === eventId);
            if (event) {
                draft.success = 'passed';
                draft.location = event.venue;
                draft.notes = event.identificationNumber;
            }
        }
        ModuleActions.saveSubscription(draft.moduleId, draft.userId, draft, current);
    }
}

ModuleEnrolmentsByUser.getStores = () => ([ModuleSubscriptionStore, DialogStore]);
ModuleEnrolmentsByUser.calculateState = (prevState, { id }) => ({
    ...prevState,
    user:               (!!prevState && prevState.user) || {},
    subscriptions:      ModuleSubscriptionStore.getUserSubscriptions(id),
    dialog:             DialogStore.getOpenDialog(),
    classroomModuleIds: (!!prevState && prevState.classroomModuleIds) || [],
});

export default withId(Container.create(ModuleEnrolmentsByUser, { withProps: true }));
